import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import { withTranslation } from 'react-i18next';
import { roleLabel, withRoleLabels } from '../../../i18n/roles';
import ReactToPrint from "react-to-print";
import { PrintUserList } from '../../../components/print/PrintUserList';

class ActionsTopbar extends Component {
    constructor(props) {
        super(props);

        this.options = {
            actions: [
                { value: 0, labelKey: 'users.changeRole', type: 'roles' },
            ],
            groups: [],
            roles: [],
            categories: []
        };

        if (this.props.store.Group != null) {
            this.props.store.Group.data.forEach((group, index) => {
                this.options.groups.push({ value: index, label: group.name, id: group.id });
            });
        }

        if (this.props.store.User != null && this.props.store.User.data != null) {
            this.props.store.User.data.userlevel.forEach((level, index) => {
                this.options.roles.push({ value: index, id: level });
            });
        }

        if (this.props.store.Category != null) {
            this.props.store.Category.data.forEach((category, index) => {
                this.options.categories.push({ value: index, label: category.title, id: category.id });
            });
        }

        if (!this.props.store.User.isGroupLeader) {
            this.options.actions.push(
                { value: 1, labelKey: 'users.changeGroup', type: 'groups' },
                { value: 2, labelKey: 'message.send', type: 'message' }
            );
        } else {
            this.options.roles = this.options.roles.filter((userRole) => userRole.id !== "admin" && userRole.id !== "super_admin");
            this.options.actions.push(
                { value: 1, labelKey: 'message.send', type: 'message' },
            );
        }


        this.state = {
            search: '',
            optionsName: '',
            optionsValues: [],
            dropdown: {
                actions: null,
                values: null
            }
        };

        this.onSearch = this.onSearch.bind(this);
        this.onActionsChange = this.onActionsChange.bind(this);
        this.onValuesChange = this.onValuesChange.bind(this);
        this.updateUsers = this.updateUsers.bind(this);
    }

    componentDidUpdate() {
        if (
            this.props.isChecked.length > 0 &&
            this.props.isChecked.every((user) => user.userlevel === 'team_leader') &&
            this.options.actions.find((option) => option.value === (this.props.store.User.isGroupLeader ? 1 : 2)) == null
        ) {
            this.options.actions.push(
                { value: this.props.store.User.isGroupLeader ? 1 : 2, labelKey: 'users.changeResponsibility', type: 'categories' }
            );
        }
    }

    onSearch(event) {
        this.setState({ search: event.target.value });
        this.props.updateUsers(this.doSearch(event.target.value, this.props.users));
    }

    doSearch(pattern, users) {
        let result = [];

        result = users.filter((user) => {
            let userlevel = roleLabel(this.props.t, user.userlevel);
            let group = this.props.store.Group.data.find((item) => item.id === user.group_ids[0]);

            let isIn = user.name.toLowerCase().indexOf(pattern.toLowerCase()) !== -1 ||
                user.email.toLowerCase().indexOf(pattern.toLowerCase()) !== -1 ||
                userlevel.toLowerCase().indexOf(pattern.toLowerCase()) !== -1;

            if (group != null && group.name != null) {
                isIn = isIn || group.name.toLowerCase().indexOf(pattern.toLowerCase()) !== -1;
            }

            return isIn;
        });

        return result;
    }

    resetSearch() {
        this.setState({
            search: ""
        });
    }

    onActionsChange(event) {
        if (this.options.actions[event.value].type === "message") {
            this.props.showMessageOverview()
        } else {
            this.setState((state) => ({
                ...state,
                optionsName: this.options.actions[event.value].type,
                optionsValues: this.options[this.options.actions[event.value].type],
                dropdown: {
                    ...state.dropdown,
                    actions: this.options.actions[event.value],
                    values: null
                }
            }));
        }
    }

    onValuesChange(event) {
        this.setState((state) => ({
            ...state,
            dropdown: {
                ...state.dropdown,
                values: this.options[this.state.optionsName][event.value]
            }
        }));
    }

    updateUsers() {
        if (this.state.optionsName === 'groups') {
            this.props.isChecked.forEach((user) => {
                this.props.store.User.removeUserFromGroup(user.group_ids[0], user);
                this.props.store.User.addUserToGroup(
                    this.state.dropdown.values.id,
                    user.userlevel,
                    user.userlevel === "team_leader"
                        ?
                        this.props.store.User.getUserResponsability(this.props.store.Group.data, user).id
                        :
                        this.props.store.Category.data[0].id,
                    user);
            });
        } else if (this.state.optionsName === 'roles') {
            this.props.isChecked.forEach((user) => {
                let userGroup = user.group_ids[0];

                this.props.store.User.updateUser({
                    id: user.id,
                    name: user.name,
                    phone: user.phone,
                    email: user.email,
                    userlevel: this.state.dropdown.values.id
                });

                this.props.store.User.removeUserFromGroup(userGroup, user);
                this.props.store.User.addUserToGroup(
                    userGroup,
                    this.state.dropdown.values.id,
                    this.props.store.Category.data[0].id,
                    user
                );
            });
        } else if (this.state.optionsName === 'categories') {
            this.props.isChecked.forEach((user) => {
                if (user.userlevel === "team_leader") {
                    this.props.store.User.removeUserFromGroup(user.group_ids[0], user);
                    this.props.store.User.addUserToGroup(
                        user.group_ids[0],
                        user.userlevel,
                        this.state.dropdown.values.id,
                        user
                    );
                }
            });
        }

        this.props.store.Group.getGroups(false);
        this.props.store.User.fetchAllUsers(false);
    }

    render() {
        // Action labels are UI copy and carry a key; they are labelled here rather than in the
        // constructor so they follow a language change.
        const actionOptions = this.options.actions.map(action => ({ ...action, label: this.props.t(action.labelKey) }));
        const selectedAction = this.state.dropdown.actions != null
            ? actionOptions.find(action => action.value === this.state.dropdown.actions.value)
            : null;

        // Only the role list is UI copy; group and category options carry customer data verbatim.
        const isRoleList = this.state.optionsName === 'roles';
        const optionsValues = isRoleList ? withRoleLabels(this.props.t, this.state.optionsValues) : this.state.optionsValues;
        const selectedValue = isRoleList && this.state.dropdown.values != null
            ? optionsValues.find(option => option.id === this.state.dropdown.values.id)
            : this.state.dropdown.values;

        return (
            <div className="topbar">
                <div className="actions">
                    <div className="dropdown">
                        <Dropdown
                            className="dropdown"
                            options={actionOptions}
                            value={selectedAction}
                            onChange={this.onActionsChange}
                            placeholder={this.props.t('users.actionsPlaceholder')}
                        />
                    </div>
                    <div className="dropdown">
                        <Dropdown
                            options={optionsValues}
                            value={selectedValue}
                            onChange={this.onValuesChange}
                            placeholder={this.props.t('common.selectPlaceholder')}
                        />
                    </div>
                    <button onClick={this.updateUsers} className="btn btn-primary btn-table">
                        {selectedAction != null ? selectedAction.label : this.props.t('common.apply')}
                    </button>
                </div>
                <input onChange={this.onSearch} value={this.state.search} type="text" placeholder={this.props.t('users.searchPlaceholder')} />
                {!this.props.store.User.isGroupLeader &&
                    <button onClick={this.props.addUser} className="btn btn-primary btn-table add-user">
                        {this.props.t('users.addUsers')}
                    </button>
                }
                {!this.props.store.User.isGroupLeader &&
                    <button onClick={this.props.importUsers} className="btn btn-primary btn-table ml-3">
                        {this.props.t('users.importUsers')}
                    </button>
                }
                <ReactToPrint
                    trigger={() => {
                        return (
                        <button onClick={this.print} className="btn btn-primary btn-table ml-3">
                            {this.props.t('common.print')}
                        </button>
                        );
                    }}
                    content={() => this.printUserListRef}
                />
                <div style={{ display: "none" }}>
                    <PrintUserList
                        ref={(el) => (this.printUserListRef = el)}
                        users={this.props.filteredUsers}
                        store={this.props.store}
                    />
                </div>
            </div>
        );
    }
}

// The parent holds a ref to this component and calls its methods, so the translation HOC must
// forward the ref — without `withRef` it returns a function component and the ref stays null.
export default withTranslation(undefined, { withRef: true })(ActionsTopbar);